import axios from "../../plugins/axios";

export default {
    namespaced : true,
    state : {
        types : [],
        type : {},
    }, 
    actions : {
        getTypes: ({ state }) => {
            axios.get("/api/settings/organisation/types").then(response => {
                state.types                   = response.data
                console.log(response.data)
            });
        },

        getType : ({state}, payload) => {
            axios.get("/api/settings/organisation/type/" + payload.reference).then(response => {
                state.type = response.data
                console.log(state.type)
            })
        }, 

        resetType : ({state, commit}) => {
            axios.get("/api/settings/organisation/type/" + state.type.reference).then(response => {
                state.type = response.data
                commit('app/resetChange', null, {root:true})

            })
        }, 

        updateType : ({state, commit}) => {
            axios.put("/api/settings/organisation/type/" + state.type.reference, state.type).then(response => {
                state.types = response.data
                commit('app/resetChange', null, {root:true})
            })
        } 
    }
}